<template>
  <div>
    <div
      :class="{
        'aboutStyle': langVar === 'ar',
        'aboutStyle aboutStyleEn': langVar === 'en',
      }"
    >
      <h1 class="whoHeader">{{ $t("who") }}</h1>
      <h6>
        {{ $t("about1") }}
      </h6>
      <p>
        {{ $t("about2") }}
      </p>
      <p>
        {{ $t("about3") }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store";

export default {
  data() {
    return {
      langVar: store.state.currentLang,
    };
  },
  computed: {
    ...mapState(["currentLang"]),
    currentLang() {
      return store.state.currentLang;
    },
  },
};
</script>

<style scoped>
.aboutStyle {
  margin-top: 70px;
  min-height: 600px;
  background-image: url("../../assets/images/logo3ar.png");
  background-repeat: no-repeat;
  background-position-x: 10%;
  background-color: #8d8a87;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.aboutStyleEn{
  direction: ltr !important;
  text-align: left;
  padding-left: 5%;
  background-image: url("../../assets/images/logo3.png");
  background-position-x: 95%;
}
.aboutStyle > h1 {
  color: #fdc948;
  font-size: 70px;
  font-weight: bolder;
  margin-right: 8%;
  margin-bottom: 10px;
}
.aboutStyle > h6, .aboutStyle > p{
  color: white;
  margin-right: 12%;
  margin-top: 10px;
  width: 80%;
  line-height: 35px;
  font-size: 18px;
}

.aboutStyle > h6{
  font-weight: 600;
}

.link {
  font-weight: bold;
  color: #da2f20;
  text-decoration: none;
  font-size: large;
}
.link:hover {
  color: rgb(250, 171, 171);
}

@media (max-width: 1000px) {
  .aboutStyle > h1,
  .aboutStyle > h6, .aboutStyle > p {
    margin-top: 20px;
  }
}

@media (max-width: 768px){
  .whoHeader{
    font-size: 30px !important;
  }
}
</style>